import React from 'react'

const Header = ({ children }) => {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-6 py-4">{children}</div>
    </header>
  )
}

export default Header
